import { Button } from '../ui/button';
import { ArrowRight } from 'lucide-react';
import featuredPickleball from '@/assets/featured-pickleball.jpg';

const PickleballCTA = () => {
  const handleScheduleCall = () => {
    window.open("https://calendly.com/kentfrazier/30-minutes", "_blank");
  };

  return (
    <section className="relative py-24 sm:py-32 overflow-hidden">
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: `url(${featuredPickleball})` }}
      />
      <div className="absolute inset-0 bg-foreground/85" />

      <div className="container-mobile relative z-10 text-center max-w-3xl mx-auto">
        <p className="text-primary font-semibold tracking-[0.15em] uppercase text-sm mb-4 drop-shadow-lg">
          Your Journey Begins
        </p>
        <h2 className="text-background text-3xl sm:text-4xl mb-4 drop-shadow-lg">Ready to Transform Your Game?</h2>
        <p className="text-background/70 text-lg mb-8 drop-shadow-lg">
          Book a discovery call to explore which path is perfect for your development goals.
        </p>
        <Button
          onClick={handleScheduleCall}
          className="bg-primary hover:bg-primary/90 text-primary-foreground px-8 py-6 rounded-full font-semibold transition-all duration-300 hover:shadow-lg hover:scale-105"
        >
          Schedule Your Call <ArrowRight className="h-4 w-4 ml-2" />
        </Button>
        <p className="text-background/40 text-sm mt-4 drop-shadow-lg">Free 30-minute consultation</p>
      </div>
    </section>
  );
};

export default PickleballCTA;
